var map = {
	"./CivsListBG.webp": "a126",
	"./CivsListBG_OLD.webp": "c483",
	"./babylon-Unselected.webp": "0544",
	"./babylon.webp": "6f42",
	"./celt-Unselected.webp": "7cbd",
	"./celt.webp": "63fb",
	"./egypt-Unselected.webp": "4233",
	"./egypt.webp": "e9d9",
	"./greek-Unselected.webp": "facf",
	"./greek.webp": "cd03",
	"./indian-Unselected.webp": "9159",
	"./indian.webp": "6129",
	"./norse-Unselected.webp": "c8a9",
	"./norse.webp": "36ddf",
	"./persia-Unselected.webp": "9f6d",
	"./persia.webp": "676b",
	"./roman-Unselected.webp": "d799",
	"./roman.webp": "4f6d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a7e";